<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="flexs mb20">
        <el-image style="width: 50px; height: 50px;border-radius: 50%;" :src="info.headImg" v-if="info.headImg" :preview-src-list="[info.headImg]"></el-image>
        <img style="width: 50px; height: 50px;" src="@/assets/du_logo.png" v-else />
        <span class="ml10 font16">{{info.userName}}</span>
        <!-- <div class="sex-box flexs"> -->
        <i style="font-size: 13px;" :class="info.sex==1?'el-icon-male':'el-icon-female'" :style="{'color':info.sex==1?'#60B7DC':'#F59494'}" class="ml5"></i>
        <!-- </div> -->
        <div class="font12 label-box ml10">内部员工</div>
      </div>
      <el-descriptions class="margin-top" title="" :column="10" direction="vertical" :colon="false" :labelStyle="{'color':'#8F8E8E','paddingBottom':'0px'}">
        <el-descriptions-item label="电话">{{info.userPho}}</el-descriptions-item>
        <el-descriptions-item label="部门">{{info.deptName}}</el-descriptions-item>
        <el-descriptions-item label="入职时间" v-if="info.jobStatus==1">{{info.entryTime}}</el-descriptions-item>
        <el-descriptions-item label="离职时间" v-if="info.jobStatus==0">{{info.resignationTime}}</el-descriptions-item>
        <el-descriptions-item label="状态">{{info.jobStatus==1?'在职':'离职'}}</el-descriptions-item>
      </el-descriptions>
      <el-tabs v-model="activeType" @tab-click="handleCheck" class="mt20 ">
        <el-tab-pane label="课程信息" name="0"></el-tab-pane>
        <el-tab-pane label="会议记录" name="1"></el-tab-pane>
      </el-tabs>
      <!-- <Title class="mt20">{{activeType==0?'其他信息':'统计'}}</Title>
      <template v-if="activeType==0">
        <el-descriptions class="margin-top" title="" :column="3">
          <el-descriptions-item label="注册APP时间">{{info.firstLoginAppTime}}</el-descriptions-item>
          <el-descriptions-item label="入职时间">{{info.resignTime}}</el-descriptions-item>
          <el-descriptions-item label="离职时间" v-if="info.state==30">{{info.resignTime}}</el-descriptions-item>
        </el-descriptions>
      </template> -->
      <template v-if="activeType==0">
        <Title>统计</Title>
        <el-descriptions title="">
          <el-descriptions-item label="赠送">1</el-descriptions-item>
          <el-descriptions-item label="购买">2</el-descriptions-item>
          <el-descriptions-item label="支付金额">3</el-descriptions-item>
          <el-descriptions-item label="现金">3</el-descriptions-item>
          <el-descriptions-item label="金额">3</el-descriptions-item>
          <el-descriptions-item label="零售价">3</el-descriptions-item>
          <el-descriptions-item label="学费增额">3</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-if="activeType==1">
        <Title>统计</Title>
        <el-descriptions title="">
          <el-descriptions-item label="报名会议">{{meetingInfo.count}}次</el-descriptions-item>
          <el-descriptions-item label="签到会议">{{meetingInfo.signInCount}}次</el-descriptions-item>
          <el-descriptions-item label="未签到">{{meetingInfo.notSignInCount}}次</el-descriptions-item>
          <el-descriptions-item label="报名费">{{meetingInfo.fee}}元</el-descriptions-item>
        </el-descriptions>
      </template>
    </el-card>
    <el-dialog title="管辖区域" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
      <el-tree :data="areaOptions" :props="defaultProps"></el-tree>
    </el-dialog>

  </div>
</template>

<script>
import userApi from '@/api/sys/user'
import meetingSignUpApi from '@/api/meeting/meetingSignUp'
export default {
  props: ['rowId'],
  data() {
    return {
      radio1: '全部',
      activeType: '0',
      list: [],
      formVisible: false,
      info: {
        userHeadImg: ''
      },
      technicalState: 1,
      shareData: null,
      defaultProps: {
        children: 'child',
        label: 'areaName'
      },
      areaOptions: [],
      statisticsList: [],
      meetingInfo: {
        count: 0,
        signInCount: 0,
        notSignInCount: 0,
        fee: 0
      },
    }
  },
  created() {
    this.handleShow()
    this.getMeeting()
    // if (this.rowItem.areaCount) this.changeIdentity()
    // if (this.technicalState) this.getShareData()
  },
  methods: {
    async getMeeting() {
      const { data } = await meetingSignUpApi.getCountFeeByUserInfo({ userInfoId: this.rowId })
      if (data) {
        for (let key in this.meetingInfo) {
          if (this.meetingInfo.hasOwnProperty(key)) { // 确保key是对象自身的属性
            if (data[key]) {
              this.meetingInfo[key] = data[key]
            }
          }
        }
      }
      // console.log('会议数据data: ',data);
    },
    handleShow() {
      userApi.fetchById(this.rowId)
        // technicianInfoApi.fetchById(this.rowItem.id)
        // technicianInfoApi.fetchById(4)
        .then((data) => {
          this.info = data.data;
          // this.getServiceNum()
          // this.getClientNum()
          console.log('this.form: ', this.info);
        })
    },
    showArea() {
      this.formVisible = true
    },
    // 获取地区
    changeIdentity() {
      technicianAreaApi.fetchTreeList({
        technicianInfoId: this.rowItem.id,
        isGetAuth: true
      }).then(({
        data
      }) => {
        this.areaOptions = data
      })
    },
    // 切换
    handleCheck() {
      if (this.activeType == 1) {
        this.statisticsList = [{
          label: '普通客户',
          key: '8',
          unit: '人',
          value: 0
        },
        {
          label: '体验班',
          key: '7',
          unit: '人',
          value: 0
        },
        {
          label: '研修班',
          key: '6',
          unit: '人',
          value: 0
        },
        ]
        // this.getClientNum()
      }
      if (this.activeType == 2) {
        this.statisticsList = [{
          label: '营销经理',
          key: '',
          unit: '人',
          value: 0
        },
        {
          label: '大区经理',
          key: '10',
          unit: '人',
          value: 0
        },
        {
          label: '地区经理',
          key: '20',
          unit: '人',
          value: 0
        },
        {
          label: '县区经理',
          key: '30',
          unit: '人',
          value: 0
        }
        ]
        // this.getServiceNum()
      }
      if (this.activeType == 3) {
        this.statisticsList = [{
          label: '总业绩',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '直属客户业绩',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '团队业绩',
          key: '',
          unit: '元',
          value: 0
        }
        ]
        // this.getChildNum()
      }
      if (this.activeType == 4) {
        this.statisticsList = [{
          label: '累计佣金',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '预计佣金',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '已提现佣金',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '可提现佣金',
          key: '',
          unit: '元',
          value: 0
        }
        ]
      }
    },
    // 获取预约服务数量
    async getServiceNum() {
      const {
        data
      } = await technicianServiceOrderApi.getStatusCount({
        technicianInfoId: this.rowItem.id
      })
      // console.log('服务数量: ',data);
      if (data.length) {
        data.forEach(item => {
          this.statisticsList.map(i => {
            if (i.key == item.id) i.value = item.count
            return i
          })
          this.statisticsList[0].value = data.reduce((total, current) => {
            return total + current.count
          }, 0)
        })
        console.log('this.statisticsList: ', this.statisticsList);
      }
    },
    // 获取客户数量
    async getClientNum() {
      const {
        data
      } = await clientListApi.getCountByLevelGroup({
        technicianId: this.info.id
      })
      // console.log('客户数量data: ',data);
      if (data.length) {
        data.forEach(item => {
          this.statisticsList.map(i => {
            if (i.key == item.id) i.value = item.count
            return i
          })
        })
        // console.log('this.statisticsList: ',this.statisticsList);
      }
    },
    // 获取团队数量
    async getChildNum() {
      const {
        data
      } = await technicianInfoApi.getChildCount(this.info.id)
      // console.log('data: ',data);
      this.statisticsList[0].value = data
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }

}
</script>

<style lang="scss" scoped>
.sex-box {
  border-radius: 50%;
  border: 1px solid;
  width: 16px;
  height: 16px;
  margin: 0 4px;
}

.label-box {
  background: #1596cd1a;
  padding: 2px;
  border-radius: 2px;
  color: #1596cd;
}

.grid-content {
  background: #60b7dc33;
  padding: 20px 30px 30px;
  border-radius: 20px;
  font-size: 20px;
  width: 350px;
  height: 153px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
